import { redirectToErrorPage } from "components/ErrorComponent";

export const fetchCookie = async () => {
  try {
    const response = await fetch('/account/getCookie', {
      method: 'GET',
      credentials: 'include', // Include cookies with the request
      headers: {
        'Content-Type': 'text/html; charset=utf-8'
      }
    });

    if (!response.ok) {
        redirectToErrorPage();
    }
    return await response.text(); 
  } catch (error) {
    redirectToErrorPage();
  }
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

export const getCsrfToken = async () => {
  //Check if we already have a token in cookies
  const existingToken = getCookie('CSRF-TOKEN');

    if (existingToken) {
      return existingToken;
    }

  // If no token exists, fetch a new one
  try {
    const response = await fetch('/account/csrfToken', {
      method: 'GET',
      credentials: 'include', // Important for sending cookies along with the request
    });

    if (response.ok) {
      const data = await response.json();
      // Save the token to a cookie if not already present
      document.cookie = `CSRF-TOKEN=${data.token}; SameSite=Lax; Secure; path=/;`; // Ensure it's available to your app
      return data.token;
    } else {
      console.error('Failed to get CSRF token:', response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    return null;
  }
};